import auth from './auth.js';
import data from './data/data.js';
import project from './project/index.js';
import rbac from './rbac.js';
import results from './results/index.js';
import theme from './theme.js';
import profile from './profile/profile.js';
import progression from './progression/index.js';

export default { auth, rbac, results, data, project, theme, profile, progression };
